import React, { useContext, useEffect, useState } from 'react';

const FilterContext = React.createContext();

const FilterProvider = ({ children, posts }) => {
  const [activeFilters, setActiveFilters] = useState([]);
  const [filterButtons, setFilterButtons] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState(null);

  useEffect(() => {
    // Set Filter Buttons
    const arr = [];
    posts.map(({ ecospheres }) =>
      ecospheres.map(({ label }) => {
        if (!arr.includes(label)) arr.push(label);
      })
    );
    setFilterButtons(arr);
  }, [posts]);

  const onClickFilter = (label) => {
    const filters = [...activeFilters];

    if (!filters.includes(label)) filters.push(label);
    else {
      const idx = filters.indexOf(label);
      filters.splice(idx, 1);
    }

    const arr = [];

    posts.map((post, i) => {
      post.ecospheres.find(({ label }, k) => {
        if (filters.includes(label)) {
          arr.push(post);
          return true;
        }
      });
    });

    const filtered = arr.sort((a, b) => Number(b.sortDate) - Number(a.sortDate));

    setActiveFilters(filters);
    setFilteredPosts(filtered);
  };

  const store = {
    activeFilters,
    filterButtons,
    onClickFilter,
    clearFilters: () => setActiveFilters([]),
    posts: !!activeFilters.length ? filteredPosts : posts,
  };

  return <FilterContext.Provider value={store}>{children}</FilterContext.Provider>;
};

export const useFilter = () => useContext(FilterContext);

export default FilterProvider;
